<footer class="bg-gray-900 text-white py-12">
    <div class="max-w-7xl mx-auto px-4 xl:px-0">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div class="space-y-4">
                <h3 class="text-xl font-bold">truckhandel.ch</h3>
                <p class="text-gray-300 text-sm">{{'footer.tagline' | translate}}</p>
                <div class="flex space-x-4">
                    <a href="https://www.linkedin.com/company/truckhandel-ch" target="_blank" rel="noopener noreferrer"
                        class="text-gray-400 hover:text-white transition-colors"
                        aria-label="{{'footer.social.linkedin' | translate}}"
                        title="{{'footer.social.linkedin' | translate}}">
                        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                            <path
                                d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                        </svg>
                    </a>
                </div>
            </div>

            <div class="space-y-4">
                <h4 class="text-lg font-semibold">{{'footer.products.title' | translate}}</h4>
                <ul class="space-y-2 text-sm">
                    <li>
                        <a routerLink="/listings" class="text-gray-300 hover:text-white transition-colors">
                            {{ 'footer.products.allProducts' | translate }}
                        </a>
                    </li>
                    <li>
                        <a routerLink="/listings/category/construction-machinery"
                            class="text-gray-300 hover:text-white transition-colors">
                            {{ 'footer.products.heavyEquipment' | translate }}
                        </a>
                    </li>
                    <li>
                        <a routerLink="/listings/category/spare-parts"
                            class="text-gray-300 hover:text-white transition-colors">
                            {{ 'footer.products.parts' | translate }}
                        </a>
                    </li>
                </ul>
            </div>

            <div class="space-y-4">
                <h4 class="text-lg font-semibold">{{'footer.support.title' | translate}}</h4>
                <ul class="space-y-2 text-sm">
                    <li>
                        <a routerLink="/help/contact" class="text-gray-300 hover:text-white transition-colors">
                            {{'footer.support.helpCenter' | translate}}
                        </a>
                    </li>
                </ul>
            </div>

            <div class="space-y-4">
                <h4 class="text-lg font-semibold">{{'footer.legal.title' | translate}}</h4>
                <ul class="space-y-2 text-sm">
                    <li>
                        <a routerLink="/legal/privacy" class="text-gray-300 hover:text-white transition-colors">
                            {{'footer.legal.privacy' | translate}}
                        </a>
                    </li>
                    <li>
                        <a routerLink="/legal/terms" class="text-gray-300 hover:text-white transition-colors">
                            {{'footer.legal.terms' | translate}}
                        </a>
                    </li>
                    <li>
                        <a routerLink="/legal/cookies" class="text-gray-300 hover:text-white transition-colors">
                            {{'footer.legal.cookies' | translate}}
                        </a>
                    </li>
                    <li>
                        <a routerLink="/legal/accessibility" class="text-gray-300 hover:text-white transition-colors">
                            {{'footer.legal.accessibility' | translate}}
                        </a>
                    </li>
                </ul>
            </div>
        </div>

        <div class="border-t border-gray-700 mt-8 pt-8 text-center text-sm text-gray-400">
            <p>
                &copy; {{ currentYear }} truckhandel.ch. All rights reserved.
            </p>
        </div>
    </div>
</footer>